import { render } from "./subcategory-modal.vue?vue&type=template&id=72aedf1d"
import script from "./subcategory-modal.vue?vue&type=script&lang=js"
export * from "./subcategory-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__